import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Button, ButtonProps } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    neutral: Palette["primary"];
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});

export const OrangeTextButton = React.forwardRef<
  HTMLButtonElement,
  {
    onClick: any;
    text: any;
    disabled: boolean;
  } & Pick<ButtonProps, "sx" | "className">
>(({ onClick, text, disabled, className, sx, ...props }, ref) => {
  return (
    <ThemeProvider theme={theme}>
      <Button
        ref={ref}
        type="button"
        color="primary"
        onClick={onClick}
        disabled={disabled}
        className={className ?? "hover:bg-[#E67300]"}
        sx={sx}
        {...props}
      >
        {text}
      </Button>
    </ThemeProvider>
  );
});

OrangeTextButton.displayName = "OrangeTextButton";
